import Box from "@mui/material/Box";
import { LIST_GRID_EXPANDED_INSET } from "@/components/list-grid/ListGridTemplate";
import type { Order } from "@/api/order/_models/Order";
import { OrderListExpandedDetail } from "./OrderListExpandedDetail";
import { OrderListExpandedExternalSystems } from "./OrderListExpandedExternalSystems";
import { OrderListExpandedLineItems } from "./OrderListExpandedLineItems";

interface OrderListExpandedProps {
  order: Order;
}

/** An expanded order row's panel: details, external systems and line items side by side, stacking on narrower screens. */
export const OrderListExpanded = (props: OrderListExpandedProps) => {
  const { order } = props;

  return (
    <Box
      sx={{
        columnGap: 6,
        display: "grid",
        gridTemplateColumns: {
          xs: "minmax(0, 1fr)",
          md: "repeat(2, minmax(0, 1fr))",
          lg: "minmax(0, 1fr) minmax(0, 1.3fr) minmax(0, 1.4fr)",
        },
        pb: 2.5,
        pl: LIST_GRID_EXPANDED_INSET,
        pr: 3,
        pt: 0.5,
        rowGap: 2,
        "& > .OrderListExpanded-items": {
          gridColumn: { md: "1 / -1", lg: "auto" },
        },
      }}
    >
      <OrderListExpandedDetail order={order} />
      <OrderListExpandedExternalSystems order={order} />
      <OrderListExpandedLineItems lines={order.lines} />
    </Box>
  );
};
